module.exports = __webpack_public_path__ + "static/img/about_bg_04_zh.7f06b98.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/about/about_bg_04_zh.png
// module id = 3eFM
// module chunks = 34